<template>
    <div style="height: 100%;width: 100%">
        <component :is="currenIndex" v-cloak />
    </div>
</template>

<script>
  import sctterMap from '@/components/sctterMap'
  import dotMap from '@/components/dotMap'
  import heatMap from '@/components/heatMap'
  import allMap from "@/components/allMap"

  export default {
    components: {
      sctterMap,
      dotMap,
      heatMap,
      allMap,
    },
    data() {
        return {
            currenIndex: 'sctterMap',
        }
    },
    methods: {
        changeList(val) {
            if (val.type == this.currenIndex) {
                return
            }
            this.currenIndex = val.type
        },
    }
  }
  </script>